<template>
  <div class="life-table">
    <h1>収支表</h1>
    <InputForm/>
    <LifeTable :inOut2="inOut"/>
    <MoneyGraph/>
  </div>
</template>

<script>
import InputForm from '@/components/InputForm.vue'
import LifeTable from '@/components/LifeTable.vue'
import MoneyGraph from '@/components/MoneyGraph.vue'
export default {
  name: 'FinancialPlan',
  components: {
    InputForm,
    LifeTable,
    MoneyGraph
  },
  data () {
    return {
      inOut: [
        {year: 2017, in: 1040, out: 1076}
      ]
    }
  }
}
</script>

<style scoped lang="less">

</style>
